import React, { useEffect, useState, useRef } from "react";
import Pin from "../../../assets/pin.png";
import Dart from "../../../assets/dart.png";
import BlogItem from "./BlogItem";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
const Blog = () => {
    const [blog, setBlog] = useState([]);
    const titleRef = useRef(null);
    const blogRef = useRef(null);
    const descendant = gsap.utils.selector(blogRef);

    const BlogUrl = "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@eyujunior";
    useEffect(() => {
        const fetchBlog = async () => {
            const response = await fetch(BlogUrl);
            const data = await response.json();

            setBlog(data.items);

            gsap.fromTo(
                titleRef.current,
                { y: 0 },
                {
                    y: -50,
                    duration: 1,
                    scrollTrigger: {
                        trigger: titleRef.current,
                    },
                }
            );

            gsap.fromTo(
                descendant(".blog-card"),
                { y: 0 },
                {
                    y: -50,
                    duration: 2,
                    stagger: {
                        amount: 1.5,
                        from: "start",
                    },
                    ease: "Power3.easeOut",
                    scrollTrigger: {
                        trigger: descendant(".blog-cards"),
                    },
                }
            );
        };

        fetchBlog();
    }, []);
    return (
        <div id="blog" className="layout text-white md:mb-16 mb-0">
            <h1
                ref={titleRef}
                className="relative mb-8 flex items-center justify-center font-semibold text-5xl lg:mb-10 xl:text-6xl 2xl:text-7xl">
                Blog
            </h1>

            <div
                ref={blogRef}
                className="blog-cards grid blog-ref grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 gap-8 2xl:gap-12 mb-32 2xl:mb-48">
                {blog.map((item) => {
                    return (
                        <BlogItem
                            key={item.title}
                            title={item.title}
                            date={item.pubDate}
                            link={item.link}
                            image={item.thumbnail}
                            description={item.description}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default Blog;
